export interface CoordinatePoint {
  latitude: number | null;
  longitude: number | null;
}

interface CompleteCoordinatePoint {
  latitude: number;
  longitude: number;
}

const earthRadiusM = 6371000;

const toRadians = (value: number) => (value * Math.PI) / 180;

export const hasCoordinates = (point: CoordinatePoint): point is CompleteCoordinatePoint => (
  point.latitude != null && point.longitude != null
);

export const getDistanceMeters = (from: CoordinatePoint, to: CoordinatePoint) => {
  if (!hasCoordinates(from) || !hasCoordinates(to)) return null;

  const fromLat = toRadians(from.latitude);
  const toLat = toRadians(to.latitude);
  const deltaLat = toRadians(to.latitude - from.latitude);
  const deltaLng = toRadians(to.longitude - from.longitude);

  const a = Math.sin(deltaLat / 2) ** 2
    + Math.cos(fromLat) * Math.cos(toLat) * Math.sin(deltaLng / 2) ** 2;

  return 2 * earthRadiusM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
